import * as msal from '@azure/msal-browser';

export const GOOGLE_CLIENT_ID = (import.meta.env.VITE_GOOGLE_CLIENT_ID as string) || '';

export const microsoftLoginRequest: msal.PopupRequest = {
  scopes: ['User.Read'],
};

// Lazy singleton — MSAL throws at construction with an empty clientId,
// so we defer creation until the button is actually clicked.
let _msalInstance: msal.PublicClientApplication | null = null;

export async function getMsalInstance(): Promise<msal.PublicClientApplication> {
  if (!_msalInstance) {
    const clientId = (import.meta.env.VITE_MICROSOFT_CLIENT_ID as string) || '';
    const tenantId = (import.meta.env.VITE_MICROSOFT_TENANT_ID as string) || 'common';

    // Use VITE_MICROSOFT_REDIRECT_URI if set (must match exactly what's registered in Azure AD).
    // Falls back to window.location.origin for local development.
    const redirectUri = (import.meta.env.VITE_MICROSOFT_REDIRECT_URI as string) || window.location.origin;

    _msalInstance = new msal.PublicClientApplication({
      auth: {
        clientId,
        authority: `https://login.microsoftonline.com/${tenantId}`,
        redirectUri,
      },
      cache: {
        cacheLocation: 'sessionStorage',
      },
    });
  }

  await _msalInstance.initialize();
  return _msalInstance;
}
